import ReducerUtils from "../../../utils/ReducerUtils"
import Actions from "../../../model/constant/actions"

const ImpressionsByDevice = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_IMPRESSIONS_BY_DEVICE] : (_,action)=>action.status
})

export default ImpressionsByDevice
